import { type Moment, moment } from "../date";
import { guardNumber } from "../numbers";
import type { Tables } from "../types";
import { calculateTourWaveCutoffTime } from "./calculate-tour-wave-cutoff-time";

/**
 * This function is used to validate the current time against the cutoff point of a tourwave.
 */
export function getTourWaveCutoffValidation(
	date: string | Moment,
	tourWave: Tables<"tourWaves">,
): boolean {
	const current = moment();
	const cutoffTime = calculateTourWaveCutoffTime(
		moment(date).setTime(tourWave.startTime),
		guardNumber(tourWave.cutoffOffset),
	);
	return current.isBefore(cutoffTime);
}
